/**
 * Angular imports.
 */
import { Component, HostListener, Input, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

/**
 * Service imports.
 */
import { FunCollectionService } from '../../../../common/common-functions/fun-collection.service';
import { MasterserviceService } from '../../../../dataservices/master-service/masterservice.service';
import { MultiLangService } from '../../../../dataservices/master-service/multi-lang.service';
import { PostApiService } from '../../../../dataservices/post-api.service';
import { JwtDecodeService } from '../../../../dataservices/jwt-decode.service';
import { NewLanguageService } from '../../../../dataservices/new-language/new-language.service';
import { DataStorageService } from '../../../../dataservices/data-storage.service';
import { ConsentService } from './../../../../dataservices/consent/consent.service';
import { AuthService } from './../../../../auth/auth.service';
import { ImageGroupService } from 'src/app/dataservices/master-service/image-group.service';
/**
 * Rxjs imports.
 */
import { Subject, Subscription } from 'rxjs';

/**
 * Webinar Card Component
 */
import { WEBINAR_STATUS, NUMBERS, WEBINAR_PAGE_TYPE, CONSENT_TYPE, SHOW_CONSENT_CHECKBOX, IS_CONSENT_GIVEN, ONLY_LABEL_CONSENT, REPOST_STATUS, SCREEN_NAME, ARTICLE_TUTORIAL_LOCAL_STORAGE, REPOST_INFO_LOCAL_STORAGE, POST_TYPE, POSTING_PROGRESS, REPOST_TYPE_ITEM, STORY_CREATION_TYPE, CREATE_STORY_TYPES, TEMPLATE_TYPE, USER_STORY_NUDGE, ACTION_ON, ACTION_TYPE, CTA_TYPE, PRODUCT_TYPE_CONSTANT_NAME  } from '../../../../constants/app.constants';
import { GetService } from './../../../../dataservices/get.service';
import { WebinarModel } from './../../../models/webinar.model';

/**
 * Constant import.
 */
import { PRODUCT_TYPE_CONSTANT } from './../../../../constants/app.constants';
import { CLICK, CLICK_SUB, LIKE } from 'analytics2.0/dist/core/constants/analytic.interface';
/**
 * Interface import.
 */
import { AnalyticsInterface } from '../../../../analytics-event/analytics.model';
import { DqVideoPlayerService } from '../../../../dataservices/dqVideoPlayer/dq-video-player.service';
import { takeUntil } from 'rxjs/operators';

/**
 * sdk imports
 */
import { Analytics } from 'analytics2.0';

@Component({
  selector: 'app-webinar-card',
  templateUrl: './webinar-card.component.html',
  styleUrls: ['./webinar-card.component.scss']
})
export class WebinarCardComponent implements OnInit, OnChanges, OnDestroy {
  @Input() docCardObj;
  @Input() docTalkSection;
  @Input() listLength;
  @Input() callingFrom;

  @Input() parentEntityType: string;
  @Input() parentEntityCode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public ngbDDL: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public singlengbDDL: any;
  @Input() callingfrom;
  public feed_bookmark_loader = false;
  public feed_like_loader = false;
  public width = '0%';
  public channelsub: object;
  public webinarStatus = WEBINAR_STATUS;
  public numberConstant = NUMBERS;
  public apiInprogess = false;
  private subscriptionList: Subscription = new Subscription();

  public isMetaGenerated = false;

  /**
   * Check if consent button is disabled or not.
   * Flag to show the consent switch.
   * consent validation error messages.
   */
  public isConsentButtonDisabled = false;
  public showConsentCheckBox = SHOW_CONSENT_CHECKBOX;
  public consentErrorValidationMsg = { invalid: '' };

  /**
   * Screen name from which that card is called.
   */
  @Input() screenName?: string;
  /**
   * use of docTalkobj for id
   */
  @Input() docTalkObj;

  /**
   * Constant Imports.
   */
  public productType = PRODUCT_TYPE_CONSTANT;
  /*
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();

  public createRepostScreen = SCREEN_NAME.CREATE_REPOST;
  public callingScreenName = SCREEN_NAME;

  public createStoryScreen =  SCREEN_NAME.CREATE_USER_STORY;
  /**
   * Repost info popover status.
   */
  public showRepostPopOver = false;

  /**
   * To close data stream
   */
  private notifier$ = new Subject();

  /**
   * Necessary instances
   */
  constructor(
    public igs: ImageGroupService,
    private masterService: MasterserviceService,
    public multiLangService: MultiLangService,
    private router: Router,
    public fcs: FunCollectionService,
    private jwtSer: JwtDecodeService,
    public postSer: PostApiService,
    private dss: DataStorageService,
    public mls: NewLanguageService,
    private getService: GetService,
    public consentService: ConsentService,
    public authService: AuthService,
    private getApiService: GetService,
    private dqService: DqVideoPlayerService,
    private activatedRoute: ActivatedRoute,
    private analyticSdk : Analytics
  ) {
  }

  /**
   *Set analytics object.
   */
  ngOnInit(): void {
    this.checkConsentButtonStatus();
    /**
     * Check if we need to show repost tolltip or not.
     */
    if (localStorage.getItem(REPOST_INFO_LOCAL_STORAGE.KEY) !== NUMBERS.ONE.toString() && this.docCardObj?.showRepostTooltip === this.dss.reposTooltip &&
      this.docCardObj?.channel?.content_visibility?.display !== NUMBERS.ZERO && this.docCardObj?.channel?.content_visibility?.display !== NUMBERS.TWO) {
      this.showRepostPopOver = true;
    }

    if (this.callingfrom === SCREEN_NAME.COMMUNITY_DETAILS) {
      this.activatedRoute.paramMap.pipe(
        takeUntil(this.notifier$)
      ).subscribe(params => {
        this.dqService.communityId = params && params.get('communityId');
      });
    }
  }

  /**
   * Check the status of the consent button.
   */
  checkConsentButtonStatus(): void {
    const checkDisableSub = this.consentService.getRegisteredButtonStatus()
      .subscribe((res: boolean) => {
        if (res && this.consentService.productTypeId === this.docCardObj.webinar_id) {
          if (this.dss.isWebinarShareEnabled && !this.docCardObj?.notify_me_flags?.registered_button?.is_registered && 
            this.docCardObj?.notify_me_flags?.consent?.show_checkbox !== this.showConsentCheckBox.EXPLICIT) {
            this.createStoryThroughNudge(this.mls.languageText.stories_tutorial.key9, this.mls.languageText.stories_tutorial.key10, USER_STORY_NUDGE.is_story_webinar_register_enabled);
          }
          this.docCardObj.notify_me_flags.registered_button.is_registered = 1;
        }
      });
    this.subscriptionList.add(checkDisableSub);
    const consentButtonSub = this.postSer.getConsentButtonStatus()
      .subscribe(res => this.isConsentButtonDisabled = res);
    this.subscriptionList.add(consentButtonSub);
    this.checkForIsConsentFormOpen();
  }

  /**
   * ngOnChanges
   */
  ngOnChanges(): void {
    this.initializeNgbDdl();
  }

  /**
   * initializeNgbDdl
   */
  initializeNgbDdl(): void {
    this.ngbDDL = {
      class: 'm', calling_from: 'webinar card',
      data: [
        { index: 1, action: 'share', text: this.mls.languageText.webinar_card.key8, product_type: 27, product_type_id: this.docCardObj.webinar_id, src: '' },
        { index: 0, action: 'report', text: this.mls.languageText.webinar_card.key9, product_type: 27, product_type_id: this.docCardObj.webinar_id, src: '' },
        { index: 0, action: 'repost', text: 'Repost', product_type: 27, product_type_id: this.docCardObj.webinar_id, src: '' },
      ]
    };



    this.singlengbDDL = {
      class: 'm', calling_from: 'webinar card',
      data: [
        { index: 0, action: 'report', text: this.mls.languageText.webinar_card.key9, product_type: 27, product_type_id: this.docCardObj.webinar_id },
      ]
    };



  }

  /**
   * share
   */
  productShare(share_content, product_type, product_type_id): void {
    const x = [{ share_url: '', share_contentt: share_content, product_type: product_type, product_type_id: product_type_id }];
    this.fcs.productShare(x, this.callingfrom);
  }

  /**
   * navigate to detail
   */
  navigatetodetail(data): boolean {
    if (this.parentEntityType && this.parentEntityCode) {
      const clickData: CLICK_SUB = {
        entity_type: this.parentEntityType,
        entity_code: this.parentEntityCode,
        sub_entity_type: PRODUCT_TYPE_CONSTANT_NAME.WEBINAR,
        sub_entity_code: this.docCardObj.product_type_id,
        current_screen_name: this.fcs.currentScreename,
        action_on: ACTION_ON.WEBINAR,
        action_type: ACTION_TYPE.CLICK,
        cta_type: CTA_TYPE.SUB_CARD,
        start_time: new Date().getTime(),
        rank: 0
      };
      this.analyticSdk.analyticService.CLICK_SUB(clickData);
    }
    else {
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.WEBINAR, this.docCardObj.product_type_id,this.fcs.currentScreename, CTA_TYPE.CARD, ACTION_TYPE.CLICK,ACTION_ON.WEBINAR, null);
    }
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }

    if (data.product_type == PRODUCT_TYPE_CONSTANT.WEBINAR) {

      if (this.callingfrom === SCREEN_NAME.COMMUNITY_DETAILS) {
        this.dqService.calledFrom = this.callingfrom;
      }

      if (this.docCardObj.channel == null) {

        this.fcs.navigateToWebinarDetail(data.webinar_id);
        this.fcs.navigateToTop();

      } else if (this.docCardObj.channel.is_subscribed == 0 && this.docCardObj.channel.is_product_view == 0) {
        this.channelsub = {
          docCardObj: this.docCardObj.channel,
          showSubscribeModal: true,
          callingFrom: 'webinarCard',
          id: this.docCardObj.webinar_id

        };

        this.dss.subscribeChannelCard.next(this.channelsub);

      } else if (this.docCardObj.channel.is_product_view == 1 || this.docCardObj.channel.is_subscribed == 1) {

        this.fcs.navigateToWebinarDetail(data.webinar_id);
        this.fcs.navigateToTop();


      }
    } else if (data.product_type == 8) {
      this.router.navigateByUrl('cme/detail/' + data.course_id);
    }

  }

  /**
   * product Bookmark
   */
  productBookmark(): void {
    this.feed_bookmark_loader = true;
    const action = (this.docCardObj.is_bookmarks == 0) ? 'add' : 'delete';
    if (this.docCardObj.is_bookmarks == 0) {
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.WEBINAR, this.docCardObj.product_type_id,this.fcs.currentScreename, CTA_TYPE.ENGAGEMENT_BAR, ACTION_TYPE.CLICK,ACTION_ON.BOOKMARK, null);
    }
    this.subscriptionList.add(this.postSer.productBookmark(this.docCardObj.product_type, this.docCardObj.webinar_id, 'add').subscribe(resDat => {
      this.feed_bookmark_loader = false;
      this.jwtSer.decodeData(resDat).then(data => {
        if (data['status'] == 1) {

          this.docCardObj.is_bookmarks = (action == 'add') ? 1 : 0;

          this.fcs.showSuccess(data['msg'], 'Success');
        } else if (data['status'] == 0) {
          this.fcs.errorHandeler(data);
          return;
        }
      }, () => {
        this.feed_bookmark_loader = false;
      });
    }));
  }

  /**
   * product Like
   */
  productLike(): void {
    if (this.feed_like_loader == true) { return; }
    if (this.docCardObj.is_like == true) { return; }
    this.feed_like_loader = true;
    const likeData : LIKE =   {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.WEBINAR,
      entity_code: this.docCardObj.doctalks_id,
      current_screen_name: this.fcs.currentScreename,
      start_time: new Date().getTime(),
      action_on : ACTION_ON.LIKE,
      action_type : ACTION_TYPE.CLICK,
      cta_type : CTA_TYPE.ENGAGEMENT_BAR,  
  }
    this.analyticSdk.analyticService.LIKE(likeData);
    this.subscriptionList.add(this.postSer.productLike(this.docCardObj.product_type, this.docCardObj.doctalks_id, 'like').subscribe(resData => {
      this.feed_like_loader = false;
      this.jwtSer.decodeData(resData).then(data => {
        if (data['status'] == 1) {
          this.fcs.showSuccess(data['msg'], 'Success');
          this.docCardObj.is_liked = true;
          this.docCardObj.like = this.docCardObj.like + 1;
          if (this.dss.isStoryLikeShareEnabled === 1) {
            this.createStoryThroughNudge(this.mls.languageText.stories_tutorial.key11, this.mls.languageText.stories_tutorial.key12, USER_STORY_NUDGE.is_story_first_like_enabled);
            this.dss.isStoryLikeShareEnabled = 0;
          }
        } else if (data['status'] == 0) {
          this.fcs.errorHandeler(data);
          return;
        }
      }, () => {
        this.feed_like_loader = false;
      });
    }));
  }

  /**
   * navigate To Speaker detail
   */
  navigateToSpeakerdetail(id): boolean {
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }
    this.router.navigateByUrl('webinar/speakers/detail/' + id);

  }

  /**
   * navigate to speciality
   */
  navigatetospeciality(id): boolean {
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.WEBINAR,0, this.fcs.currentScreename, CTA_TYPE.CARD, ACTION_TYPE.CLICK,ACTION_ON.SPECIALITY, null);
    this.router.navigateByUrl('webinar/speciality/list/' + id);

  }

  /**
   * reset NgbDDL Record
   */
  resetNgbDDLRecord(data): void {
    if (data.action === POST_TYPE.REPOST) {
      this.repostWebinar();
    }
  }

  /**
   * Function is used to get specialty.
   */
  getFeedTagDetails(speciality): void {
    this.analyticSdk.analyticService.CLICK(this.docCardObj.product_type,this.docCardObj.product_type_id, this.fcs.currentScreename, CTA_TYPE.TEXT, ACTION_TYPE.CLICK,ACTION_ON.SPECIALITY_HASTAG, null);
    this.dss.specialty_filter = speciality;
    this.router.navigate(['/web/list']);
  }
  /**
   * register for a webinar
   *
   * @param webinar notify
   */
  notifyMe(webinar: WebinarModel): void {
    if (this.explicitConsentConditionForRegisterButton()) {
      this.consentService.openConsentFormWebinarId = this.docCardObj.webinar_id;
      this.openConsentForm(webinar);
    } else {
      this.apiInprogess = true;
      const getWebinarNotifyMeSubscription = this.getService.getWebinarNotifyme(webinar.product_type_id,
        webinar.status, NUMBERS.ZERO, WEBINAR_PAGE_TYPE.LIST).subscribe(resData => {
          this.apiInprogess = false;
          this.jwtSer.decodeData(resData).then(response => {
            if (response.status === NUMBERS.ONE && !!response.data.notifyme_id) {
              this.analyticSdk.analyticService.CLICK(this.docCardObj.product_type,this.docCardObj.product_type_id,this.fcs.currentScreename,CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.REGISTER, null )
              webinar.notify_me_flags.registered_button.is_registered = 1;
              if (this.dss.isWebinarShareEnabled) {
                this.createStoryThroughNudge(this.mls.languageText.stories_tutorial.key9, this.mls.languageText.stories_tutorial.key10, USER_STORY_NUDGE.is_story_webinar_register_enabled);
              }
            } else if (response.status === NUMBERS.ZERO) {
              this.fcs.errorHandeler(response);
            }
          }, () => {
            this.apiInprogess = false;
          });
        });
      this.subscriptionList.add(getWebinarNotifyMeSubscription);
    }
  }

  /**
   * Check the explicit consent condition for the register button.
   */
  explicitConsentConditionForRegisterButton(): boolean {
    return (
      this.docCardObj.notify_me_flags &&
      this.docCardObj.notify_me_flags.consent.show_checkbox === this.showConsentCheckBox.EXPLICIT &&
      this.docCardObj.notify_me_flags.consent.is_consent === IS_CONSENT_GIVEN.NO &&
      this.docCardObj.notify_me_flags?.registered_button?.is_registered === this.numberConstant.ZERO
    );
  }

  /**
   * Call the dynamic form and country list api and then open the consent form modal.
   */
  openConsentForm(webinar: WebinarModel): void {
    this.consentErrorValidationMsg = {
      invalid: this.mls.languageText.consentFormValidations.key1
    };
    this.consentService.openConsentForm(this.docCardObj.product_type.toString(), webinar.product_type_id.toString(), CONSENT_TYPE.EXPLICIT_CONSENT, ONLY_LABEL_CONSENT.FALSE);
  }

  /**
   * Close the Consent.
   */
  onConsentHidden(): void {
    this.consentService.giveConsentWithoutForm(
      this.docCardObj.product_type.toString(),
      this.docCardObj.webinar_id,
      IS_CONSENT_GIVEN.NO,
      this.docCardObj.status,
      WEBINAR_PAGE_TYPE.LIST
    );
  }

  /**
   * Submit the consent.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  consentSubmit(form: any): void {
    this.consentService.consentSubmit(
      form,
      this.docCardObj.product_type.toString(),
      this.docCardObj.webinar_id,
      IS_CONSENT_GIVEN.YES,
      this.docCardObj.status,
      WEBINAR_PAGE_TYPE.LIST
    );
  }

  @HostListener('window:beforeunload.out-zone', ['$event'])
  beforeUnloadHandler(): boolean {
    /* Code to check if Page Refreshed and Consent Form Opened by User, then
       need to call notifyMe api with decline status
    */
    if (this.consentService.isConsentFormOpen) {
      const custome_id = this.authService.getbyName('profile_obj');
      localStorage.setItem('consentData', JSON.stringify({ 'isConsentFormOpen': 'true', 'webinarId': this.consentService.openConsentFormWebinarId, 'userId': custome_id }));
      return false;
    }
  }

  /**
   * Check for Is Consent Form Open and window reload
   */
  checkForIsConsentFormOpen(): void {
    if (localStorage.getItem('consentData')) {
      const custome_id = this.authService.getbyName('profile_obj');
      const consentData = JSON.parse(localStorage.getItem('consentData'));
      if (consentData['isConsentFormOpen'] === 'true'
        && consentData['webinarId'] === this.docCardObj.webinar_id
        && consentData['userId'] === custome_id) {
        this.subscriptions.add(this.getApiService.getWebinarNotifyme(this.docCardObj.webinar_id,
          this.docCardObj.status, NUMBERS.ZERO, WEBINAR_PAGE_TYPE.WEBINAR_DETAIL).subscribe(resData => {
            this.jwtSer.decodeData(resData).then(data => {
              if (data.status == NUMBERS.ONE && this.docCardObj.status === WEBINAR_STATUS.UPCOMING) {
                localStorage.removeItem('consentData');
                this.docCardObj.notify_me_flags.registered_button.is_registered = NUMBERS.ONE;
              } else if (data.status == NUMBERS.ZERO) {
                this.fcs.errorHandeler(data);
              }
            });
          }));
      }

    }
  }

  /**
   * component is called from Grand round or community details
   */
  get calledFrom(): boolean {
    return [
      this.mls.googleEventText.grandround.category,
      SCREEN_NAME.COMMUNITY_DETAILS
    ].indexOf(this.callingfrom) > NUMBERS.MINUS_ONE;
  }

  /**
   * Clean up subscription and registered eventlistener
   */
  ngOnDestroy(): void {
    this.consentService.isConsentConfirmationShown = false;
    this.consentService.isConsentFormOpen = false;
    this.consentService.setRegisteredButtonStatus(false);
    if (this.subscriptionList) {
      this.subscriptionList.unsubscribe();
    }
    this.notifier$.next();
    this.notifier$.complete();
  }
  /**
   * repost wbinar as story
   */
  repostAsStory(): void {
    this.dss.user_story_productType = PRODUCT_TYPE_CONSTANT.WEBINAR;
    this.dss.user_story_productTypeId = this.docCardObj.product_type_id;
    this.dss.create_Story_productData.next(this.docCardObj);
    this.dss.create_Template_type = TEMPLATE_TYPE.BACKGROUND;
    this.dss.storyType = CREATE_STORY_TYPES.REPOST;
    this.dss.story_creating_type = STORY_CREATION_TYPE.CREATE_STORY;
    this.dss.create_Story.next(true);
  }
  /**
   * create story through nudge
   */
  createStoryThroughNudge(storyNudgeHeading, storyNudgeDisc, nudgeType ): void {
    this.dss.storyNudgeIcon = 'assets/images/webinar-nudge.png';
    this.dss.storyNudgeHeading = storyNudgeHeading;
    this.dss.storyNudgeDisc = storyNudgeDisc,
    this.dss.storyNudgeButton = this.mls.languageText.stories_tutorial.key16;
    this.dss.story_nudge_type = nudgeType;
    this.dss.user_story_productType = PRODUCT_TYPE_CONSTANT.WEBINAR;
    this.dss.user_story_productTypeId = this.docCardObj.product_type_id;
    this.dss.create_Story_productData.next(this.docCardObj);
    this.dss.create_Template_type = TEMPLATE_TYPE.BACKGROUND;
    this.dss.storyType = CREATE_STORY_TYPES.REPOST;
    this.dss.story_creating_type = STORY_CREATION_TYPE.CREATE_STORY;
    this.dss.userStoryNudge.next(true);
  }
  /**
   * repost as story
   */
  repostWebinarType(event): void {
    if (event === REPOST_TYPE_ITEM.REPOST_ON_FEED) {
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.WEBINAR,this.docCardObj.product_type_id,
        this.fcs.currentScreename, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.REPOST_ON_FEED, null);
      this.repostWebinar();
    }
    else if (event === REPOST_TYPE_ITEM.REPOST_AS_STORY) {
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.WEBINAR,this.docCardObj.product_type_id,
        this.fcs.currentScreename, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.REPOST_ON_STORY, null);
      if (this.dss.user_profile_data.profile.permission != 'all') {
        this.fcs.assignAssociation('');
        return;
      }
      this.repostAsStory();
    }
  }
  /**
   * Repost webinar card
   */
  repostWebinar(): void {
    if (this.dss.post_process_obj.status === POSTING_PROGRESS.IN_PROGRESS) {
      this.fcs.showError('', this.mls.languageText.feed_card_screen.key22);
      return;
    }
    this.dss.repostProductId = this.docCardObj.product_type_id;
    this.dss.repostProductType = PRODUCT_TYPE_CONSTANT.WEBINAR;
    this.dss.isRepostStatus = REPOST_STATUS.ONE;
    this.fcs.navigateToFeedDetail(NUMBERS.ZERO);
    this.dss.show_feed_post_modal.next(1);
    this.dss.webinarRepostObject = this.docCardObj;
    this.closeRepostTooltip();
  }
  /**
   * Close repost tooltip
   */
  closeRepostTooltip(): void {
    this.showRepostPopOver = false;
    this.setLocalStorageIsRepostPopover();
    this.subscriptions.add(this.postSer.logTutorialView(POST_TYPE.REPOST).subscribe(() => {
      // No Code
    })
    );
  }

  /**
   * Set the repopst info popover status in local storage.
   */
  setLocalStorageIsRepostPopover(): void {
    localStorage.setItem(REPOST_INFO_LOCAL_STORAGE.KEY, REPOST_INFO_LOCAL_STORAGE.VALUE);
  }
  /**
   * Emit the generated meta.
   */
  onGenerateMeta(status: boolean): void {
    this.isMetaGenerated = status;
  }
  /**
   * show repost types
   */
  generateMeta(): void{
    this.fcs.checkRepostPopOver(this.docCardObj?.topic_community_flag,this.docCardObj?.channel?.community_id, this.docCardObj?.hl?.tcf);

    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.WEBINAR,this.docCardObj.product_type_id,
      this.fcs.currentScreename, CTA_TYPE.ENGAGEMENT_BAR, ACTION_TYPE.CLICK, ACTION_ON.REPOST, null);
    this.isMetaGenerated = true;
  }
  /**
   * close posting meta
   */
  closeMeta(event): void{
    this.fcs.isShowFeedRepost = true;
    this.isMetaGenerated = false;
  }
  /**
   * Emit action on generated Meta.
   */
  onMeta(deepLink: string): void {
      // this.emitOnMeta.emit(deepLink);
  }

}
